export const getStringCombinations = (arrays) => {
    let [first, second, ...rest] = arrays;
    if (second === undefined) {
        return first;
    }
    if (rest.length > 0) {
        second = getStringCombinations([second, ...rest]);
    }
    return first.flatMap(f => {
        return second.map(s => `${f} ${s}`);
    });
};
